export default {
  errorTitle: 'Sorry',
  errorMsg: 'Some elements of the page were not loaded.',
};
